export default __webpack_public_path__ + "static/media/general-error@2x.ec697318.png";